// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchForm_container__zf6rB","searchForm":"SearchForm_searchForm__1nMuG"};